import React, { useState, useEffect } from 'react';
import { Radio, Divider, Input, Button } from 'antd';
import {
  SortAscendingOutlined,
  SortDescendingOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const SortContent = ({
  sortOrder,
  handleSortOrderChange,
  sortField,
  handleSortChange,
  selectedMenu,
  colorByAttribute,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isClearVisible, setIsClearVisible] = useState(false);

  const handleClear = () => {
    handleSortChange('None');
  };

  useEffect(() => {
    setIsClearVisible(sortField !== 'None' && sortField !== null && sortOrder !== null);
  }, [sortField, sortOrder]);
  let allAttributes;
  if (selectedMenu === 'List') {
    allAttributes = [
      { key: 'None', label: 'None' },
      { key: 'initiativeNumber', label: '#', group: 'General' },
      { key: 'initiativeName', label: 'Name', group: 'General' },
      { key: 'initiativeNumber - initiativeName', label: '# - Name', group: 'General' },
      { key: 'weeklyStatus', label: 'Weekly status', group: 'General' },
      { key: 'AllowOnlyTo', label: 'Access', group: 'General' },
      { key: 'workstreamSponsorWorkstream', label: 'Accountable Workstream', group: 'General' },
      { key: 'workstreamLeadSubworkstream', label: ' Subworkstream', group: 'General' },
      {
        key: 'crossFunctionalSupportWorkstream',
        label: 'Cross Functional Workstream Support',
        group: 'General',
      },
      { label: 'Sector', key: 'sector', group: 'General' },
      { label: 'Subsector', key: 'subsector', group: 'General' },
      { label: 'Type', key: 'type', group: 'General' },
      { label: 'Initiative Category', key: 'initiativeCategory', group: 'General' },
      { label: 'Size', key: 'size', group: 'General' },
      { label: 'Segment', key: 'segment', group: 'General' },
      { key: 'Description', label: 'Description', group: 'General' },
      {
        key: 'selectedForToMeetingDescusion',
        label: 'Select To meeting descussion',
        group: 'General',
      },
      { key: 'Stage', label: 'Stage', group: 'Stage' },
      { key: 'Stage (simplified)', label: 'Stage (simplified)', group: 'Stage' },
      {
        key: 'Workstream Lead pending approval?',
        label: 'Workstream Lead pending approval?',
        group: 'Stage',
      },
      {
        key: 'Workstream Sponsor pending approval?',
        label: 'Workstream Sponsor pending approval?',
        group: 'Stage',
      },
      {
        key: 'Finance lead pending approval?',
        label: 'Finance lead pending approval?',
        group: 'Stage',
      },
      {
        key: 'Strategy analyst pending approval?',
        label: 'Strategy analyst pending approval?',
        group: 'Stage',
      },

      { key: 'initiativeOwnerInfo', label: 'Initiative Owner', group: 'Team' },
      { key: 'initiativeOwnerBackupInfo', label: 'Initiative Owner (back-up)', group: 'Team' },
      { key: 'workstreamLeadInfo', label: 'Workstream Lead', group: 'Team' },
      { key: 'workstreamSponsorInfo', label: 'Workstream Sponsor', group: 'Team' },
      { key: 'TO Finance Lead', label: 'TO Finance Lead', group: 'Team' },
      {
        key: 'netRecurringBenefitsLatest',
        label: 'Net recurring benefits range (latest estimate, annualized)',
        group: 'Impact summary',
      },
      {
        key: 'actualImpactUpdateCheck',
        label: 'Actual impact update check (for last completed and previous periods)',
        group: 'Impact summary',
      },
      {
        label: '(FY23-24) Actual impact update check',
        key: '(FY23-24) Actual impact update check',
        group: 'Impact summary',
      },
      {
        label: '(FY24-25) Actual impact update check',
        key: '(FY24-25) Actual impact update check',
        group: 'Impact summary',
      },
      { key: 'planningSummary', label: 'Planning summary', group: 'Timing information' },
      {
        key: 'Planning summary (simplified)',
        label: 'Planning summary (simplified)',
        group: 'Timing information',
      },
      {
        key: 'l3DateComplianceCheck',
        label: 'L3 date compliance check (forecast vs planned date)',
        group: 'Timing information',
      },
      {
        key: 'l4DateComplianceCheck',
        label: 'L4 date compliance check (forecast vs planned date)',
        group: 'Timing information',
      },
      { key: 'L1 Original Planned Date', label: 'L1 Original Planned Date', group: 'Dates' },
      { key: 'L2 Original Planned Date', label: 'L2 Original Planned Date', group: 'Dates' },
      { key: 'L3 Original Planned Date', label: 'L3 Original Planned Date', group: 'Dates' },
      { key: 'L4 Original Planned Date', label: 'L4 Original Planned Date', group: 'Dates' },
      { key: 'L5 Original Planned Date', label: 'L5 Original Planned Date', group: 'Dates' },

      { key: 'l1PlannedDate', label: 'L1 planned date', group: 'Dates' },
      { key: 'l2ForecastDate', label: 'L2 Planned date', group: 'Dates' },
      { key: 'l3PlannedDate', label: 'L3 planned date', group: 'Dates' },
      { key: 'l4PlannedDate', label: 'L4 planned date', group: 'Dates' },
      { key: 'l5ForecastDate', label: 'L5 Planned date', group: 'Dates' },

      { key: 'l0ActualDate', label: 'L0 actual date', group: 'Dates' },
      { key: 'l1ActualDate', label: 'L1 actual date', group: 'Dates' },
      { key: 'l2ActualDate', label: 'L2 actual date', group: 'Dates' },
      { key: 'l3ActualDate', label: 'L3 actual date', group: 'Dates' },
      { key: 'l4ActualDate', label: 'L4 actual date', group: 'Dates' },
      { key: 'l5ActualDate', label: 'L5 actual date', group: 'Dates' },
      {
        key: 'latestActualDateAllLGates',
        label: 'Latest actual date (All L gates)',
        group: 'Dates',
      },
      { key: 'subForL1ApprovDate', label: 'Sub. for L1 approv. date', group: 'Dates' },
      { key: 'subForL2ApprovDate', label: 'Sub. for L2 approv. date', group: 'Dates' },
      { key: 'subForL3ApprovDate', label: 'Sub. for L3 approv. date', group: 'Dates' },
      { key: 'subForL4ApprovDate', label: 'Sub. for L4 approv. date', group: 'Dates' },
      { key: 'subForL5ApprovDate', label: 'Sub. for L5 approv. date', group: 'Dates' },
      { key: 'cancellationDate', label: 'Cancellation date', group: 'Dates' },
      {
        key: 'actualKpiUpdateCheck',
        label: 'Actual KPI update check (for last completed and previous periods)',
        group: 'KPI summary',
      },
      {
        key: 'Pipeline weekly variance (L0+)',
        label: 'Pipeline weekly variance (L0+)',
        group: 'Change (current vs last week)',
      },
      {
        key: 'Pipeline weekly variance (L1+)',
        label: 'Pipeline weekly variance (L1+)',
        group: 'Change (current vs last week)',
      },
      {
        key: 'Pipeline weekly variance (L2+)',
        label: 'Pipeline weekly variance (L2+)',
        group: 'Change (current vs last week)',
      },
      {
        key: 'Pipeline weekly variance (L3+)',
        label: 'Pipeline weekly variance (L3+)',
        group: 'Change (current vs last week)',
      },
      {
        key: 'Pipeline weekly variance (L4+)',
        label: 'Pipeline weekly variance (L4+)',
        group: 'Change (current vs last week)',
      },

      { key: 'Number of Attachment', label: 'Number of Attachment', group: 'Other' },

      { key: 'Has qualitative KPI?', label: 'Has qualitative KPI?', group: 'Other' },
      { key: 'hasFinancialImpact', label: 'Has financial impacts?', group: 'Other' },
      { key: 'forSpecificCustomer', label: 'Is Customer Related?', group: 'Other' },
      { key: 'segmentalPBT', label: 'Segmental PBT', group: 'Other' },
      {
        key: 'Future implementation costs range',
        label: 'Future implementation costs range',
        group: 'Sequencing',
      },
    ];
  }
  if (selectedMenu === 'Table') {
    allAttributes = [
      {
        key: colorByAttribute,
        label: colorByAttribute,
      },
    ];
  }
  const filteredAttributes = allAttributes.filter(
    (attr) =>
      attr.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (attr.group && attr.group.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const groupedAttributes = {};
  filteredAttributes.forEach((attr) => {
    if (attr.group) {
      if (!groupedAttributes[attr.group]) {
        groupedAttributes[attr.group] = [];
      }
      groupedAttributes[attr.group].push(attr);
    } else {
      if (!groupedAttributes['']) {
        groupedAttributes[''] = [];
      }
      groupedAttributes[''].push(attr); // Add ungrouped
    }
  });

  return (
    <>
      <div style={{ marginBottom: '10px', position: 'fixed', zIndex: 10 }}>
        <Radio.Group value={sortOrder} onChange={handleSortOrderChange}>
          <Radio value="asc" checked>
            <SortAscendingOutlined />
            Ascending
          </Radio>
          <Radio value="desc">
            <SortDescendingOutlined />
            Descending
          </Radio>
        </Radio.Group>
      </div>
      <Divider style={{ margin: '40px 0 10px 0' }} />
      <div
        style={{
          padding: '10px',
          maxHeight: '500px',
          overflowY: 'auto',
          backgroundColor: 'whitesmoke',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <Input
            placeholder="Search attributes..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ marginBottom: '10px' }}
          />
          {isClearVisible && (
            <Button
              type="text"
              onClick={handleClear}
              style={{ padding: 0, color: 'blue' }}
              icon={<CloseCircleOutlined />}
            >
              Clear
            </Button>
          )}
        </div>
        <Radio.Group onChange={(e) => handleSortChange(e.target.value)} value={sortField}>
          {Object.entries(groupedAttributes).map(([groupName, attributes]) => (
            <div key={groupName}>
              {groupName && (
                <div style={{ fontWeight: 'bold', marginTop: '10px', fontSize: 14, color: '#333' }}>
                  {groupName}
                </div>
              )}
              {attributes.map((attr) => (
                <div key={attr.key}>
                  <Radio value={attr.key} style={{ display: 'block' }}>
                    {attr.label}
                  </Radio>
                </div>
              ))}
            </div>
          ))}
        </Radio.Group>
      </div>
    </>
  );
};

export default SortContent;
